import React from 'react'
import "./taxBenefits.scss"
// You would need to import these images or use appropriate pathss
import TaxBenefitsWithBG from '../../public/images/sip-select/tax_benefits_with_bg.svg';
import { useNavigate } from 'react-router-dom';

const TaxBenefits = () => {
    const navigate = useNavigate();

    const learnHowMethod = () => {
        navigate('/mydonations');
    }

    return (
        <div className='tax-benefits-conatiner'>
            <div className='left'>
                <div className='text-section'>
                    <p>Did you know that you can now <br /><span>avail tax benefits</span> on all your donations!</p>
                </div>
                <div className='link' onClick={learnHowMethod}>
                    Learn How
                </div>

            </div>
            <div className='right'>
                <img src={TaxBenefitsWithBG}></img>
            </div>
        </div>
    )
}

export default TaxBenefits;